import { Globals } from "../CoreApp/Globals";

export function IsDBChart() {
  return Globals._wsMgr.IsDBChart();
}
